import React from "react";
import { Image, Tooltip } from "@chakra-ui/react";
import moblyzeLogo from "../../assets/img/moblyzeLogo.png";

// MoblyzeUserLogo flags a candidate who has signed up on Moblyze (an active
// user, as opposed to a pending Bullhorn import). It mirrors ImportedInvited's
// shape: the Moblyze mark alone tells the story, no label.
//
// Pass `isMoblyzeUser` (typically `!candidate.isExternal`) so callers can
// short-circuit the render without a wrapping ternary.
function MoblyzeUserLogo({ isMoblyzeUser, ...props }) {
  return isMoblyzeUser && (
    <Tooltip label="Moblyze user" hasArrow>
      <Image
        src={moblyzeLogo}
        alt="Moblyze"
        boxSize="20px"
        objectFit="contain"
        data-testid="moblyze-user-pill"
        {...props}
      />
    </Tooltip>
  );
}

export default MoblyzeUserLogo;
